import { windowUtils } from './windowUtils';

export const getInstitution = () => {
  const { hostname } = windowUtils;
  const defaultInstitution = process.env.REACT_APP_INSTITUTION || 'app';
  return process.env.REACT_APP_LOCAL === 'true'
    ? defaultInstitution
    : hostname.split('.')[1];
};

export const getInstitutionURL = () =>
  `https://${getInstitution()}.aula.education/`;
